// ABOUTME: Rapid-entry dialog for adding multiple text items in sequence.
// ABOUTME: Stays open after each Add so users can add several items before clicking Done.
import Button from '@mui/material/Button'
import { InputDialog } from './InputDialog'

interface Props {
  open: boolean
  onClose: () => void
  title: string
  label: string
  value: string
  onChange: (value: string) => void
  onAdd: () => void
  error?: string | null
}

export function AddItemDialog({ open, onClose, title, label, value, onChange, onAdd, error }: Props) {
  return (
    <InputDialog
      open={open}
      onClose={onClose}
      title={title}
      label={label}
      value={value}
      onChange={onChange}
      onSubmit={onAdd}
      error={error}
    >
      <Button onClick={onClose}>Done</Button>
      <Button onClick={onAdd}>Add</Button>
    </InputDialog>
  )
}
